import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import toast from "react-hot-toast";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
// Modals
import AddTransactionOnTransaction from "./AddTransactionOnTransaction";
import TransactionUpdater from "./TransactionUpdater";
import TransactionCatUpdater from "./TransactionCatUpdater";
import JournalPrinting from "./JournalPrinting";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxProject from "../../util/remote/ajaxProject";
import JournalPrintingWzStatement from "./JournalPrintingWzStatement";
function PaidJournals() {
  const { userId } = useContext(AuthContext);
  const trans_type = "journal";
  const [loading, setLoading] = useState(false);
  const [unpaidJournals, setUnpaidJournals] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projectID, setProjectID] = useState("");
  const [start_date, setStart_date] = useState("");
  const [state, setState] = useState("paid");
  const [to_date, setTo_date] = useState("");
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState([]);
  // Modals state
  const [UpdateVoucher, setUpdateVoucher] = useStateCallback(false);
  const [voucherCat, setVoucherCat] = useStateCallback(false);
  const [printing, setPrinting] = useStateCallback(false);
  // Fetch projects for filter
  const getProjects = async () => {
    const server_response = await ajaxProject.getProjectsMinnimalDataCliented();
    if (server_response.status === "OK") {
      const allOption = { id: "", project_name: "All Projects" };
      setProjects([allOption, ...server_response.details]);
    } else {
      setProjects("404");
    }
  };
  // Fetch unpaid journals with pagination & filters
  const fetchUnpaidJournals = async () => {
    setLoading(true);
    try {
      const data = {
        projectID: projectID,
        trans_type: "journal",
        page: page,
        start_date: start_date,
        to_date: to_date,
        state: state,
      };
      const response = await ajaxAccounting.getUnpaidJournals(data);
      if (response.status === "OK") {
        setUnpaidJournals(response.details);
      } else {
        setUnpaidJournals([]);
        toast.error("No unpaid journals found");
      }
    } catch (err) {
      toast.error("Error fetching unpaid journals");
      setUnpaidJournals([]);
    }
    setLoading(false);
  };
  useEffect(() => {
    getProjects();
    const today = new Date().toISOString().split("T")[0];
    setTo_date(today);
  }, []);
  useEffect(() => {
    fetchUnpaidJournals();
  }, [projectID, page, start_date, to_date]);
  // Pagination handlers
  const setNextPageNumber = () => {
    if (meta.length !== page) setPage(page + 1);
  };
  const setPreviousPageNumber = () => {
    if (page !== 1) setPage(page - 1);
  };
  const setPageNumber = (e, item) => {
    setPage(item);
  };
  // --- Modal Handlers ---
  const handleVoucherUpdate = (item) => {
    setUpdateVoucher(false, () =>
      setUpdateVoucher(
        <TransactionUpdater
          isOpen={true}
          data={item}
          function={fetchUnpaidJournals}
        />
      )
    );
  };
  const handlePrinting = (folioID) => {
    setPrinting(false, () =>
      setPrinting(
        <JournalPrinting isOpen={true} folioID={folioID} type="journal" />
      )
    );
  };

  const handvoucherCAtItem = (reference, item) => {
    setVoucherCat(false, () =>
      setVoucherCat(
        <TransactionCatUpdater
          isOpen={true}
          function={fetchUnpaidJournals}
          reference={reference}
          item={item}
        />
      )
    );
  };
  const [statement, setStatement] = useStateCallback(false);

  const handlestatement = (e, id, reff) => {
    e.preventDefault();
    setStatement(false, () =>
      setStatement(
        <JournalPrintingWzStatement
          folioID={id}
          type={trans_type}
          reff={reff}
          isOpen={true}
        />
      )
    );
  };
  return (
    <div className="row">
      {/* Modals */}
      {statement}
      {UpdateVoucher}
      {voucherCat}
      {printing}
      {/* Filters */}
      <div className="col-lg-3 col-md-6 mb-3">
        <Select
          onChange={(e) => setProjectID(e.id)}
          getOptionLabel={(option) => option.project_name}
          getOptionValue={(option) => option.id}
          options={Array.isArray(projects) && projects}
          value={
            (Array.isArray(projects) &&
              projects.find((p) => p.id === projectID)) ||
            projects[0]
          }
          placeholder="Filter by Project"
        />
      </div>
      <div className="col-lg-3 col-md-6 mb-3">
        <input
          type="date"
          value={start_date}
          onChange={(e) => setStart_date(e.target.value)}
          className="form-control"
          placeholder="From"
        />
      </div>
      <div className="col-lg-3 col-md-6 mb-3">
        <input
          type="date"
          value={to_date}
          onChange={(e) => setTo_date(e.target.value)}
          className="form-control"
          placeholder="To"
        />
      </div>
      <div className="col-lg-3 col-md-6 mb-3">
        <button
          className="btn btn-primary col-12"
          onClick={fetchUnpaidJournals}
        >
          <i className="fa-brands fa-searchengin"></i> Get Data
        </button>
      </div>
      {/* Table */}
      <div className="col-lg-12 col-md-12">
        <div className="table-responsive">
          {loading && <Loader />}
          <table
            className="table table-striped table-bordered"
            style={{ border: "orange 3px groove" }}
          >
            <thead>
              <tr>
                <th>#</th>
                <th>reff</th>
                <th>Supplier_invo_ref</th>
                <th>Date</th>
                <th>Project</th>
                <th>ledger Debited</th>
                <th>ledger Credited</th>
                <th>Amount</th>
                <th>details</th>
                <th>cost Allocation Item</th>
                <th>Reciever</th>
                <th>Created By</th>
              </tr>
            </thead>
            <tbody>
              {unpaidJournals.length > 0 ? (
                unpaidJournals.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.folio_reff}</td>
                    <td>
                      {item.supplier_reff}
                      <button
                        onClick={() => handleVoucherUpdate(item)}
                        style={{ borderRadius: "5px", margin: "2px" }}
                        className="btn ripple btn-warning btn-sm"
                      >
                        <i className="fa-solid fa-pen-to-square"></i> Update
                      </button>
                      <button
                        onClick={(e) =>
                          handlestatement(e, item.folioID, item.supplier_reff)
                        }
                        style={{
                          borderRadius: "5px",
                          margin: "2px",
                        }}
                        className="btn ripple btn-primary btn-sm"
                      >
                        <i class="fa-regular fa-eye"></i>
                        &nbsp; statement
                      </button>
                      <button
                        onClick={() => handlePrinting(item.folioID)}
                        style={{ borderRadius: "5px", margin: "2px" }}
                        className="btn ripple btn-secondary btn-sm"
                      >
                        <i className="fa-solid fa-print"></i> Print
                      </button>
                    </td>
                    <td>{item.date.short_date}</td>
                    <td>{item.projectID?.project_name}</td>
                    <td>{item.ledgerID_debited?.Ledger_name}</td>
                    <td>{item.ledgerID_credited?.Ledger_name}</td>
                    <td>{item.amount?.amount_p}</td>
                    <td style={{ width: "200px", wordWrap: "break-word" }}>
                      {item.description}
                    </td>
                    <td>
                      {item.catID ? (
                        item.catID.item
                      ) : (
                        <button
                          onClick={() =>
                            handvoucherCAtItem(item.reference, item)
                          }
                          style={{ borderRadius: "5px" }}
                          className="btn ripple btn-primary btn-sm"
                        >
                          <i className="fa-solid fa-plus"></i> Add CAC
                        </button>
                      )}
                    </td>
                    <td>{item.reciever}</td>
                    <td>{item.created_by?.name}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={13} className="text-center">
                    No unpaid journals found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default PaidJournals;
